// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__Y70V9","title":"NotFound_title__FDIm+","text":"NotFound_text__pxsKJ","button":"NotFound_button__OwVMY","assistSection":"NotFound_assistSection__dPGY1"};